import * as types from 'store/modules/votefriend/mutation-types'
import votefriend from 'api/votefriend'
import swal from 'sweetalert'
import votefriendLabels from 'assets/labels/votefriend'
import { constLabels } from 'assets/js/constLabels.js'

export default {
  state: {
    labels: votefriendLabels,
    index: {
      total: 0,
      rows: []
    },
    indexSelected: {
      id: '',
      codfrnid: '1',
      namempt: '',
      nickname: '',
      desc_codpos: '',
      score: '',
      remark: '',
      dtevote: '',
      timvote: '',
      namimage: ''
    },
    profile: {
      namempt: '',
      codpos: '',
      desc_codpos: '',
      namimage: ''
    },
    pageCurrent: 1,
    maxPage: 0,
    numberPerPage: 18
  },
  getters: {
    [types.GET_VOTEFRIEND_LABELS] (state) {
      return state.labels
    },
    [types.GET_VOTEFRIEND_INDEX] (state) {
      return state.index
    },
    [types.GET_VOTEFRIEND_INDEX_SELECTED] (state) {
      return state.indexSelected
    },
    [types.GET_VOTEFRIEND_PAGECURRENT] (state) {
      return state.pageCurrent
    },
    [types.GET_VOTEFRIEND_MAXPAGE] (state) {
      return state.maxPage
    },
    [types.GET_VOTEFRIEND_NUMPERPAGE] (state) {
      return state.numberPerPage
    },
    [types.GET_VOTEFRIEND_PROFILE] (state) {
      return state.profile
    }
  },
  mutations: {
    [types.SET_VOTEFRIEND_LABELS] (state, labels) {
      state.labels.en = labels.en
      state.labels.th = labels.th
    },
    [types.SET_VOTEFRIEND_INDEX] (state, index) {
      state.index = index
    },
    [types.SET_VOTEFRIEND_INDEX_SELECTED] (state, indexSelected) {
      state.indexSelected = indexSelected
    },
    [types.SET_VOTEFRIEND_PAGECURRENT] (state, pageCurrent) {
      state.pageCurrent = pageCurrent
    },
    [types.SET_VOTEFRIEND_MAXPAGE] (state, maxPage) {
      state.maxPage = maxPage
    },
    [types.SET_VOTEFRIEND_PROFILE] (state, profile) {
      state.profile = profile
    }
  },
  actions: {
    [types.RECEIVED_VOTEFRIEND_LABELS] ({ commit }) {
      votefriend.getLabels()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_VOTEFRIEND_LABELS, data.labels)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_VOTEFRIEND_INDEX] ({ commit }) {
      votefriend.getIndex()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_VOTEFRIEND_INDEX, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
          let objData = {
            total: 0,
            rows: []
          }
          commit(types.SET_VOTEFRIEND_INDEX, objData)
        })
    },
    [types.RECEIVED_VOTEFRIEND_PROFILE] ({ commit }) {
      votefriend.getProfile()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_VOTEFRIEND_PROFILE, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
          let objData = {
            namempt: '',
            codpos: '',
            desc_codpos: '',
            namimage: ''
          }
          commit(types.SET_VOTEFRIEND_PROFILE, objData)
        })
    },
    [types.POST_VOTEFRIEND_SAVE] ({ commit, dispatch }, saveParams) {
      swal({
        title: constLabels('confirmTitle'),
        text: constLabels('msgConfirmSave'),
        html: true,
        showCancelButton: true,
        closeOnConfirm: false,
        confirmButtonText: constLabels('ok'),
        cancelButtonText: constLabels('cancel')
      },
      function (isConfirm) {
        if (isConfirm) {
          swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
          votefriend.postSave(saveParams)
            .then((response) => {
              const data = JSON.parse(response.request.response)
              dispatch(types.RECEIVED_VOTEFRIEND_INDEX)
              swal({
                title: '', text: data.response, html: true, type: 'success'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
              saveParams.modalPopupClose.click()
            })
            .catch((error) => {
              let message = error
              if (error.response) {
                const data = error.response.data
                message = data.response
              }
              swal({
                title: '', text: message, html: true, type: 'error'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
        }
      })
    }
  }
}




// WEBPACK FOOTER //
// ./src/store/modules/votefriend/index.js